<template>
  <div class="container p-0">
    <div class="row justify-content-center p-2">
      <div class="col">
        <h2>{{ t("WAIT_A_MOMENT") }}</h2>
        <p>{{ t("WAIT_VALIDATION_TEXT") }}</p>
      </div>
      <div class="spinner-wrapper">
        <Spinner />
      </div>
    </div>
  </div>
  <HelpMessage />
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import Spinner from "@/apps/merchant3/shared-components/ui/Spinner.vue";
import HelpMessage from "@/apps/merchant3/components/HelpMessage.vue";

const { t } = useI18n();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
h2 {
  color: $pj-color-black300;
}
p {
  font-size: 16px;
  color: $pj-color-gray;
}
.spinner-wrapper {
  height: 360px;
}
</style>
